import api from "./api.js";

export default class CouponApi {
  static async getList(data) {
    return await api.get(`api/member-coupon`, data);
  }
}
